<template>
  <el-form
    ref="form"
    label-width="150px"
    label-position="right"
    :inline="true"
    size="mini"
    class="search-form"
  >
    <el-row v-for="g in groupConfig" :key="g.text">
      <h4 class="title">{{g.text}}</h4>
      <el-card>
        <el-row>
          <el-col v-for="c in g.confs" :key="c.hash" :span="c.span" :class="c.labelClass||''">
            <ElementCreator :config="c" />
          </el-col>
        </el-row>
      </el-card>
    </el-row>
  </el-form>
</template>

<script>
import ElementCreator from './ElementCreator'
import { routeInfoPRDC, routeInfoCSR } from '../router'
import { mapState } from 'vuex'

export default {
  name: 'BaseInfoInputs',
  components: {
    ElementCreator
  },
  props: {
    config: {
      type: Array,
      required: true
    },
    routeName: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      basicCsr: [
        {
          text: 'Basic',
          location: [0, 6]
        },
        {
          text: 'Contact',
          location: [6, 14]
        },
        {
          text: 'Address',
          location: [14, 19]
        },
        {
          text: 'Classification',
          location: [19, 33]
        }
      ],
      basicProductForTyres: [
        {
          text: 'Basic',
          location: [0, 6]
        },
        {
          text: 'Category',
          location: [6, 7]
        },
        {
          text: 'Brands & Tags',
          location: [8, 15]
        },
        {
          text: 'Specs for Tyres',
          location: [15, 23]
        }
      ],
      basicProductForWheels: [
        {
          text: 'Basic',
          location: [0, 6]
        },
        {
          text: 'Category',
          location: [6, 8]
        },
        {
          text: 'Brands & Tags',
          location: [8, 15]
        },
        {
          text: 'Specs for Wheels',
          location: [23, 29]
        }
      ],
      basicProductForOthers: [
        {
          text: 'Basic',
          location: [0, 6]
        },
        {
          text: 'Category',
          location: [6, 7]
        },
        {
          text: 'Brands & Tags',
          location: [8, 15]
        }
      ]
    }
  },
  computed: {
    groupConfig () {
      switch (this.routeName) {
        case routeInfoPRDC:
          return this.formatConfigForProduct()
        case routeInfoCSR:
          return this.formatConfigForBasicCsr()
        default:
          return []
      }
    },
    ...mapState({
      category: state => state.baseinfo.product.category
    })
  },
  methods: {
    formatConfigForBasicCsr () {
      const configs = []
      for (let i = 0; i < this.basicCsr.length; i++) {
        const cell = this.basicCsr[i]
        const conf = {
          text: cell.text,
          confs: this.config.slice(cell.location[0], cell.location[1])
        }
        configs.push(conf)
      }
      return configs
    },
    formatConfigForProduct () {
      const configs = []
      let group = null
      switch (this.category) {
        case 1:
          group = this.basicProductForTyres
          break
        case 2:
          group = this.basicProductForWheels
          break
        default:
          group = this.basicProductForOthers
          break
      }

      for (let i = 0; i < group.length; i++) {
        const cell = group[i]
        const conf = {
          text: cell.text,
          confs: this.config.slice(cell.location[0], cell.location[1])
        }
        configs.push(conf)
      }

      return configs
    }
  }
}
</script>

<style lang="scss" scoped>
.btns-row {
  justify-content: center;
}
.el-divider {
  margin: 6px 0;
  background-color: #e5e5f14b;
}
.title {
  text-align: left;
  font-size: 16px;
}
</style>
